export const SPA_AVAILABILITY_TIMEOUT = 30000; // 30 seconds;
export const SPA_TIMESLOT_AVAILABILITY_TIMEOUT = 30000; // 30 seconds;
export const SPA_PACKAGE_TIMESLOT_AVAILABILITY_TIMEOUT = 60000; // 60 seconds;
